import { useMemo } from 'react';

import { useLocation } from 'react-router-dom';

import { ACTIVITY_PATHS, PRODUCT_BASE_PATHS } from '@cast/console-constants';
import { Product } from '@cast/console-types';

export function useSelectedProduct(): Product | undefined {
  const location = useLocation();

  return useMemo(() => {
    // Activity paths (/activity/*) map to the auditLog product
    if (location.pathname.startsWith(ACTIVITY_PATHS.activity)) {
      return 'auditLog';
    }

    for (const [feature, path] of Object.entries(PRODUCT_BASE_PATHS)) {
      if (location.pathname.startsWith(path)) {
        return feature as Product;
      }
    }
    return undefined;
  }, [location.pathname]);
}
